import { VideoIds } from "@/constants";
import { playVideo } from "./play-video";

export const onScreenScroll = () => {
  const scrollY = window.scrollY;

  if (scrollY > 0) return;

  const heroBanner = document.querySelector(`#${VideoIds.HeroBanner}`);

  if (!heroBanner) return;

  playVideo(heroBanner as HTMLVideoElement);
};
